module.exports = __webpack_public_path__ + "assets/7876fed3d0b84b02f07fe009ac2dfe05.mp3";